import {VehicleTypeDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'CREATE_CUSTOMER_CATEGORY';

export async function createVehicleType(
    userData: Record<string, string>,
    vehicleType: Record<string, any>
) {
    try {
        const result = await VehicleTypeDao.createVehicleType(userData.userToken, vehicleType);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
